// src/theme.js
import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#C9922A',
      light: '#DDB04E',
      dark: '#9E7218',
      contrastText: '#111111',
    },
    secondary: {
      main: '#22C55E',
      light: '#4ADE80',
      dark: '#16A34A',
    },
    error: {
      main: '#EF4444',
    },
    background: {
      default: '#FAF9F7',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#111111',
      secondary: '#78716C',
    },
    divider: 'rgba(120,100,80,0.12)',
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: { fontWeight: 900, letterSpacing: '-0.05em', lineHeight: 0.92 },
    h2: { fontWeight: 800, letterSpacing: '-0.04em', lineHeight: 0.95 },
    h3: { fontWeight: 700, letterSpacing: '-0.03em' },
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontWeight: 600, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    subtitle1: { letterSpacing: '-0.01em' },
    body1: { letterSpacing: '-0.01em' },
    button: { fontWeight: 600, textTransform: 'none', letterSpacing: '0.01em' },
    overline: { letterSpacing: '0.14em', fontSize: '0.65rem', fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          backgroundImage: 'none',
          boxShadow: '0 1px 4px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.07)',
          border: 'none',
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          backgroundColor: '#141414',
        },
      },
    },
  },
});

export default theme;
